import { EventEmitter, Injectable } from "@angular/core";
import { Constants } from "src/app/constants";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Router } from '@angular/router';
import { ColumnWidthService } from "../ColumnWidthService";

interface boxLevelHistoryInput {
  orderNumber: any;
  supplierCode: any;
  namc: any;
  dockCode: any;
  kanban: any;
  exportIndicator: boolean;
}

interface reportODSHistoryInput {
  orderNumber: any;
  orderNamc: any;
  orderSupplierCode: any;
  orderDockCode: any;
}
@Injectable({
  providedIn: "root",
})
export class CommonService {
  unloadEmit: EventEmitter<any> = new EventEmitter<any>();
  private userLoggedIn = new Subject<boolean>();
  constructor(
    public constants: Constants,
    public ngxUiLoaderService: NgxUiLoaderService,
    public router: Router,
    private columnWidthService: ColumnWidthService,

  ) {
    this.ValidateRouteByRole.subscribe((data: any) => {
      if (!this.verifyByRole(data)) {
        this.router.navigate(['/unauthorized', 'fvm', 'false'])
      }
    });

    this.userLoggedIn.next(false);
  }
  DOCInquirySubmit: EventEmitter<any> = new EventEmitter<any>();
  RLInquirySubmit: EventEmitter<any> = new EventEmitter<any>();
  ExitBtnExiter: EventEmitter<any> = new EventEmitter<any>();
  ValidateRouteByRole: EventEmitter<any> = new EventEmitter<any>();
  private refresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private myBehaviorSubject = new BehaviorSubject<string>('');

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }
  setValue(value: string) {
    this.myBehaviorSubject.next(value);
  }

  getValue() {
    return this.myBehaviorSubject.asObservable();
  }
  public getRefresh(): Observable<boolean> {

    return this.refresh.asObservable();
  }

  public setRefresh(value: boolean): void {

    this.refresh.next(value);
  }
  private boxLevelHistoryInput: boxLevelHistoryInput;
  private reportODSHistoryInput: reportODSHistoryInput;
  static namc(test: any): string {
    let ret = "";
    if (test !== undefined) {
      const code = test.substring(0, 2);
      if (code === "01") {
        if (test.toUpperCase() === "01TPR") {
          ret = "KT";
        } else {
          ret = "K";
        }
      } else if (code === "02") {
        if (test.toUpperCase() === "02TPR") {
          ret = "IT";
        } else {
          ret = "I";
        }
      } else if (code === "03") {
        if (test.toUpperCase() === "03TPR") {
          ret = "XT";
        } else {
          ret = "TX";
        }
      } else if (code === "04") {
        if (test.toUpperCase() === "04TPR") {
          ret = "RT";
        } else {
          ret = "MS";
        }
      } else if (code === "11") {
        ret = "BD";
      } else if (code === "12") {
        ret = "CP";
      } else if (code === "13") {
        ret = "TA";
      } else if (code === "14") {
        if (test.toUpperCase() === "14TPR") {
          ret = "WT";
        } else {
          ret = "WV";
        }
      } else if (code === "15") {
        if (test.toUpperCase() === "15TPR") {
          ret = "AT";
        } else {
          ret = "AL";
        }
      } else if (code == "16") {

        if (test.toUpperCase() == "16TPR") {
          ret = "NT";
        }
        else {
          ret = "NC";
        }
      }
      else if (code === "20") {
        if (test.toUpperCase() === "20TPR") {
          ret = "BT";
        } else {
          ret = "BC";
        }
      } else if (code === "21") {
        if (test.toUpperCase() === "21TPR") {
          ret = "CT";
        } else {
          ret = "C";
        }
      } else if (code === "22") {
        ret = "NU";
      } else if (code === "23") {
        ret = "SB";
      } else if (code === "25") {
        if (test.toUpperCase() === "25TPR") {
          ret = "GT"; //TMMGT Trial
        } else {
          ret = "GP"; //TMMGT PROD Orders, 25TMG
        }
        // Mexico Yard
      } else if (code === "26") {
        if (test.toUpperCase() === "26TPR") {
          ret = "ZT"; //MTMUS Trial
        } else {
          ret = "ZP"; //MTMUS PROD
        }
        // Mexico Yard
      } else if (code === "60") {
        ret = "EX";
      } else if (code === "50") {
        ret = "SK"; // service Kentucky
      } else if (code === "51") {
        ret = "SC"; // service California
      } else if (code === "70") {
        ret = "TT"; // 70TPR  TTC Trial
      } else if (code === "71") {
        ret = "PT"; // 71TPR  NAPE Trial
      } else if (code === "72") {
        ret = "QT"; // 72TPR  NAQD Trial
      }
    }
    return ret;
  }
  setBoxLevelHistoryInput(data: boxLevelHistoryInput) {
    this.boxLevelHistoryInput = data;
  }
  getBoxLevelHistoryInput(): boxLevelHistoryInput {
    return this.boxLevelHistoryInput;
  }

  setReportODSHistoryInput(data: reportODSHistoryInput) {
    this.reportODSHistoryInput = data;
  }
  getReportODSHistoryInput(): reportODSHistoryInput {
    return this.reportODSHistoryInput;
  }
  static formatDate(dateInput: Date) {
    console.log("dateInput", dateInput);
    const date = new Date(dateInput);
    console.log("date", date);
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day}  ${hours}:${minutes}`;
  }
  static getOrderScannedSkids(order: any) {
    if (order == null || order.discrepancyRouteConnection == null) {
      return 0;
    }

    let numScanned = 0;
    let rc = order.discrepancyRouteConnection;
    if (rc.type == "OUTBOUND" && order.scannedSkids != null) {
      for (let i = 0; i < order.scannedSkids.length; i++) {
        let skid = order.scannedSkids[i];
        if (skid.pickedRc) {
          numScanned += 1;
        }
      }
    } else if (rc.type == "INBOUND" && order.scannedSkids != null) {
      for (let i = 0; i < order.scannedSkids.length; i++) {
        let skid = order.scannedSkids[i];
        if (skid.unloadedRc) {
          numScanned += 1;
        }
      }
    }

    return numScanned;
  }
  static createRouteType(order: any) {
    console.log(order)
    let type = "";
    if (order == null) {
      return type;
    }

    if (order.discrepancyPlannedRouteConnection != null) {
      type = order.discrepancyPlannedRouteConnection.type;
    }

    if (order.discrepancyUnPlannedRouteConnection != null) {
      type = order.discrepancyUnPlannedRouteConnection.type;
    }

    if (type == "INBOUND") {
      type = "U/L";
    }
    if (type == "OUTBOUND") {
      type = "R/L";
    }
    console.log("type", type);
    return type;
  }
  static createDiscrepancyDateTimeFormat(rc: any) {
    console.log(rc, 'rc')
    let date = rc?.date;
    let time = rc?.time;

    if (date == null || time == null) {
      return "";
    }
    //FVMM:1544 start
    //var dateTime = date+' '+time.substring(10, 15);
    let dateTime = date + "  " + this.convertTime12to24(time.substring(10));

    return dateTime;
  }
  static convertTime12to24(dateString: any) {
    const [time, period] = dateString.split(" ");
    const [hours, minutes, seconds] = time.split(":").map(Number);
    let date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    if (period.toLowerCase() === "pm" && date.getHours() != 12) {
      date.setHours(date.getHours() + 12);
    }
    console.log(date, "date")
    const timeString = date.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
    console.log(timeString);
    return timeString;
  }

  static createSite(order: any) {
    let site = "";

    if (order == null) {
      return "";
    }

    if (order.discrepancyPlannedRouteConnection != null) {
      site = order.discrepancyPlannedRouteConnection.logisticsPoint.name;
    }

    if (order.discrepancyUnPlannedRouteConnection != null) {
      site = order.discrepancyUnPlannedRouteConnection.logisticsPoint.name;
    }

    return site;
  }

  static hasDiscrepancy(dataRow: any, discType: any) {
    let hasFound = false;

    if (dataRow == null) {
      return hasFound;
    }
    let discrepancies = dataRow.discrepancyCodes;
    if (discrepancies == null) {
      return hasFound;
    }

    for (let i = 0; i < discrepancies.length; i++) {
      let disc = discrepancies[i];
      if (disc == discType) {
        return (hasFound = true);
      }
    }

    return hasFound;
  }

  static sortReloadOrders(rows: any, lastScannedRowKey = '') {
    let sortedRows = new Array();
    let sortedRows_unplanned = new Array();
    let sortedRows_noChecksheets = new Array();
    let sortedRows_overscans = new Array();
    let sortedRows_noRequirements = new Array();
    let sortedRows_unplannedOtherRoute = new Array();
    let lastScannedRow = null;
    for (let i = 0; i < rows.length; i++) {
      let row = rows[i];
      let order = row
      var checksheet = order.checksheet;
      var real = order.scannedSkids.length;
      var planned = Number(order.checksheet.quantity);
      var unloaded = 0;
      for (var j = 0; j < order.scannedSkids.length; j++) {
        var s = order.scannedSkids[j];
        if (s.unloaded) {
          unloaded++;
        }
      }
      if (order.unplannedOtherRouteConnection) {
        sortedRows_unplannedOtherRoute[sortedRows_unplannedOtherRoute.length] = row;   // Blue
      }
      else if ((planned != real) || (planned != unloaded)) {
        sortedRows_overscans[sortedRows_overscans.length] = row; // Red
      }
      else if (checksheet == null || Number(checksheet.quantity == 0)) {
        sortedRows_noChecksheets[sortedRows_noChecksheets.length] = row; // Pink
      }
      else if (order.routeConnectionOrderType == "UNPLANNED") {
        sortedRows_unplanned[sortedRows_unplanned.length] = row; // Yellow
      }
      else {
        sortedRows[sortedRows.length] = row;
      }
    }
    let allRows = new Array();
    let lastScannedRows = new Array();
    if (lastScannedRow != null) {
      lastScannedRows[0] = lastScannedRow;
    }
    allRows = allRows.concat(
      lastScannedRows,
      sortedRows_unplannedOtherRoute,
      sortedRows_overscans,
      sortedRows_unplanned,
      sortedRows_noChecksheets,
      sortedRows,
      sortedRows_noRequirements);
    return allRows;

  }

  static sortUnloadOrders(rows: any, lastScannedRowKey = '') {
    let sortedRows = new Array();
    let sortedRows_unplanned = new Array();
    let sortedRows_noChecksheets = new Array();
    let sortedRows_overscans = new Array();
    let sortedRows_noRequirements = new Array();
    let sortedRows_unplannedOtherRoute = new Array();
    let lastScannedRow = null;
    for (let i = 0; i < rows.length; i++) {
      let row = rows[i];
      let order = row
      let checksheet = order.checksheet;
      let unloaded = this.sumUnloaded(order.scannedSkids);
      let planned = this.getPlan(order);
      if (order.unplannedOtherRouteConnection == true) {
        sortedRows_unplannedOtherRoute[sortedRows_unplannedOtherRoute.length] = row;
      }
      else if (order.noRequirement == 'T') {
        sortedRows_noRequirements[sortedRows_noRequirements.length] = row;
      }
      else if (checksheet != null && unloaded > planned) {
        sortedRows_overscans[sortedRows_overscans.length] = row;
      }
      else if (checksheet == null && unloaded > 1) {
        sortedRows_overscans[sortedRows_overscans.length] = row;
      }
      else if (order.routeConnectionOrderType == "UNPLANNED") {
        sortedRows_unplanned[sortedRows_unplanned.length] = row;
      }
      else if (checksheet == null || checksheet.scanned == false) {
        sortedRows_noChecksheets[sortedRows_noChecksheets.length] = row;
      }
      else {
        sortedRows[sortedRows.length] = row;
      }
    }
    let allRows = new Array();
    let lastScannedRows = new Array();
    if (lastScannedRow != null) {
      lastScannedRows[0] = lastScannedRow;
    }
    allRows = allRows.concat(lastScannedRows,
      sortedRows_unplannedOtherRoute,
      sortedRows_overscans,
      sortedRows_unplanned,
      sortedRows_noChecksheets,
      sortedRows,
      sortedRows_noRequirements);
    return allRows;

  }

  static sumUnloaded(scannedSkids: any): number {
    let ret = 0;
    if (scannedSkids) {
      for (const scannedSkid of scannedSkids) {
        if (scannedSkid.Unloaded) {
          ret++;
        }
      }
    }
    return ret;
  }

  static getPlan(e: any) {
    let ret = 0;
    if (e) {
      if (e.checksheet) {
        ret = e.checksheet.quantity;
      }
    }
    return ret;
  }

  static handleQty(test: any) {
    let ret = "";

    if (!this.isUndefined(test)) {

      var num = parseInt(test);

      if (num >= 0) {

        ret = test;

      }

    }
    return ret;

  }

  static isUndefined(object: any) {
    if (object == undefined || object == null) {
      return true;
    }
    else { return false; }
  }

  static Inquiry_getUBCSkidNum(UBC: any) {

    let pageBoxInquiry_currentSkidNumber = "";

    let pageBoxInquiry_currentPalletCode = "";

    let newUBC;

    if (UBC.length > 34) {

      pageBoxInquiry_currentSkidNumber = UBC.substring(30, 33).trim();

      pageBoxInquiry_currentPalletCode = UBC.substring(33, 35).trim();

      newUBC = pageBoxInquiry_currentPalletCode + pageBoxInquiry_currentSkidNumber;

    }

    else { newUBC = UBC; }

    return newUBC;

  }

  static global_getSubTypeAction(msgType: any) {


    let msg = "";



    if (this.isUndefined(msgType)) {

      msgType = "";

    }





    if ((msgType != null) || (msgType != "")) {

      switch (msgType) {

        case "APPROVE_UNPLANNED":

          msg = 'Approve Unplanned';

          break;

        case "DENY_UNPLANNED":

          msg = 'Deny Unplanned';

          break;

        case "WRONG_POST_SCANNED":

          msg = 'Wrong Post for Route';

          break;

        case "WRONG_POSTED_ROUTE":

          msg = 'Wrong Post Route';

          break;

        case "WRONG_POSTED_RUN":

          msg = 'Wrong Post Run';

          break;

        case "WRONG_POSTED_DATE":

          msg = 'Wrong Post Date';

          break;

        case "WRONG_POSTED_TIME":

          msg = 'Wrong Post Time';

          break;

        case "WRONG_MAIN_ROUTE":

          msg = 'Wrong Main Route';

          break;

        case "WRONG_MR_RUN":

          msg = 'Wrong MR Run';

          break;

        case "WRONG_MR_DATE":

          msg = 'Wrong MR Date';

          break;

        case "WRONG_MR_TIME":

          msg = 'Wrong MR Time';

          break;

        case "WRONG_SUPP_ROUTE":

          msg = 'Question Supplement';

          break;

        case "WRONG_EXP_DEST":

          msg = 'Wrong Expedite Dest';

          break;

        //V3.1.0 end  

        case "EXP_NSUPPLEMENT":

          msg = 'Exp Named Suppl';

          break;

        case "EXP_USUPPLEMENT":

          msg = 'Exp Unnamed Suppl';

          break;

        case "EXP_DOCK_INVALID":

          msg = 'Exp Unusual Dock';

          break;

        case "EXPEDITE_UNPLANNED":

          msg = 'Expedite Unplanned';

          break;

        case "NORMAL_UNPLANNED":

          msg = ' Order Unplanned';

          break;   // V3.1.0I

        //V3.2.1 begin

        case "WORKDAY_MANAGEMENT":

          msg = 'Workday Mgmnt';

          break;

        case "CONNECTION_MANAGEMENT":

          msg = 'Connection Mgmnt';

          break;

        case "SHOP_MANAGEMENT":

          msg = 'Shop Mgmnt';

          break;

        case "DOCK_MANAGEMENT":

          msg = 'Dock Mgmnt';

          break;

        case "DOCK_DOOR_MANAGEMENT":

          msg = 'Dock Door Management';

          break;      // V3.6.0

        case "DOCK_SCHED_MANAGEMENT":

          msg = 'Dock Schedule Management';

          break;     // V3.6.0          

        case "RECORDS_ADDED":

          msg = 'Record Added';

          break;

        case "RECORDS_UPDATED":

          msg = 'Record Updated';

          break;

        case "RECORDS_DELETED":

          msg = 'Record Deleted';

          break;   //V3.2.1 end        

        case "ACCEPT_DUPLICATE_USL":

          msg = 'Accept Duplicate USL';

          break;   //V3.2.0 S5  

        case "TSCS_PLANNED_ORDER": /// FVM 3.4.5 start here

          msg = 'TSCS Planned Order';

          break;  // FVM 3.4.5 ends  

        case "POSTED_TO_TSCS":      // FVMM-371

          msg = 'Posted To TSCS';

          break;

        case "FAILED_TO_POST_TSCS": // FVMM-371

          msg = 'Failed To Post TSCS';

          break;

        default:

          msg = msgType;

      }

    }

    else {

      msgType = "";

    }

    return msg;

  }

  static handleDate(test: any) {

    let ret = "";
    if (!this.isUndefined(test)) {
      console.log(test.length)
      if (test.length > 16) {
        ret = test.substring(0, 16);

      }
      else {
        ret = test
      }

    }

    return ret;

  }

  verifyByRole(module: any): boolean {
    const userDetailsStr = sessionStorage.getItem("userDetails");
    let userDetails: any;
    let siteListToDisplay: any;
    if (userDetailsStr !== null)
      userDetails = JSON.parse(userDetailsStr);
    let moduleArr = module.split(',');
    let returnValue = true;
    siteListToDisplay = userDetails?.role1;
    if (siteListToDisplay && Object.keys(siteListToDisplay).length > 0) {
      moduleArr.forEach((element: any) => {
        if (returnValue) {
          returnValue = this.hasRole(siteListToDisplay, userDetails.primarySiteName, element)
        }
      });
    };
    return returnValue;
  }

  hasRole(role1: any, role: any, element: any) {
    if (role1) {
      if (role1[`${role}`] || role1['ALL']) {
        return role1[`${role}`]?.some((x: any) => {
          return x.name == element.trim()
        }) ||
          role1['ALL']?.some((x: any) => {
            return x.name == element.trim()
          })
      }
    }
  }


  static routeSummarySort(rows: any) {

    let sortedRows = new Array();

    let sortedRows_unload = new Array();

    let sortedRows_reload = new Array();

    for (let i = 0; i < rows.length; i++) {

      let row = rows[i];

      let type = row?.reltype;

      if ("INBOUND" == type) {

        sortedRows_unload[sortedRows_unload.length] = row;

      }

      else {

        sortedRows_reload[sortedRows_reload.length] = row;

      }

    }

    sortedRows_unload.sort(function (a: any, b: any) {
      let x = a?.date + a?.time;

      let y = b?.date + b?.time;

      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });

    sortedRows_reload.sort(function (a: any, b: any) {
      let x = a?.date + a?.time;

      let y = b?.date + b?.time;

      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });

    sortedRows = sortedRows.concat(sortedRows_unload, sortedRows_reload);

    return sortedRows;

  }

  static sortByDateTime(a: any, b: any) {

    let x = a.dataRow.date + a.dataRow.time;

    let y = b.dataRow.date + b.dataRow.time;

    return ((x < y) ? -1 : ((x > y) ? 1 : 0));

  }

  static updateMinWidthBasedOnMaxLength(columnKey: string, displayRowData: [], fromSource = false): void {
    if (displayRowData !== undefined) {
      let currentWord: any;
      let maxLengthWord: any;
      if (columnKey === 'previousvalue' || columnKey === 'newvalue' || columnKey === 'comhist' || columnKey === 'subtype' || columnKey === 'actiontype' || columnKey === 'createddatetime' || columnKey === 'routeconnectiondate&routeconnectiontime' || columnKey === 'skidid' || columnKey === 'routetrailerno' || columnKey === 'trailerNo') {

        if (columnKey === 'subtype' && fromSource) {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? CommonService.global_getSubTypeAction(row[columnKey]).toString().split(' ') : ''))
          maxLengthWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? CommonService.global_getSubTypeAction(row[columnKey]).toString() : ''));
        }
        else if (columnKey === 'actiontype') {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString() : ''))
        }
        else if (columnKey === 'subtype' && !fromSource) {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString().split(' ') : ''))
          maxLengthWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? CommonService.global_getSubTypeAction(row[columnKey]).toString() : ''));
        }
        else if (columnKey === 'comhist') {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString().split(/[\s|]/) : ''))
          maxLengthWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString() : ''))
        }
        else if (columnKey === 'createddatetime') {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (CommonService.handleDate(row[columnKey])).toString().split(' ') : ''))
        }
        else if (columnKey === 'routeconnectiondate&routeconnectiontime') {
          currentWord = displayRowData.map((row: any) => ((row['routeconnectiondate'] != null && row['routeconnectiondate'] != undefined && row['routeconnectiondate'] != '') ? (row['routeconnectiondate'] + " " + row['routeconnectiontime']).toString().split(' ') : ''))
        }
        else if (columnKey === 'skidid') {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? ((row[columnKey])).toString().split(' ') : ''))
        }else if (columnKey === 'routetrailerno' || columnKey === 'trailerNo' ) {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]) : ''))
        } else if (columnKey === 'newvalue' || columnKey === 'previousvalue') {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString() : ''))
        }
        else {
          currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? row[columnKey].toString().split(/[\s-]/) : ''))
        }
      }
      else if (columnKey === 'uniquebarcode' && fromSource) {
        currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (CommonService.Inquiry_getUBCSkidNum(row[columnKey])).toString().split(' ') : ''))
        maxLengthWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (CommonService.Inquiry_getUBCSkidNum(row[columnKey])).toString().split(' ') : ''))
        console.log("unique", currentWord)
      }
      else if (columnKey === 'uniquebarcode' && !fromSource) {
        currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString().split(' ') : ''))
        maxLengthWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString() : ''))
        console.log("unique", currentWord)
      }
      else {
        currentWord = displayRowData.map((row: any) => ((row[columnKey] != null && row[columnKey] != undefined && row[columnKey] != '') ? (row[columnKey]).toString().split(/[\s-]/) : ''))
      }

      let result2: any = { maxLength: 0, maxWord: "" };
      
      const words: any = [].concat(...currentWord);
      const result = words.reduce((acc: any, word: any) => {
        if (word !== undefined) {
          const wordLength = word.length;
          if (wordLength > acc.maxLength) {
            return { maxLength: wordLength, maxWord: word };
          } else {
            return acc;
          }
        }

      }, { maxLength: 0, maxWord: "" });

      if (columnKey === 'subtype' || columnKey === 'uniquebarcode' || columnKey === 'comhist') {
        const words2: any = [].concat(...maxLengthWord);
        result2 = words2.reduce((acc: any, word: any) => {
          if (word !== undefined) {
            const wordLength = word.length;
            if (wordLength > acc.maxLength) {
              return { maxLength: wordLength, maxWord: word };
            } else {
              return acc;
            }
          }
  
        }, { maxLength: 0, maxWord: "" });
      }
      
      if (result !== undefined) {
        if (columnKey === 'newvalue' || columnKey === 'previousvalue' || columnKey === 'actiontype' || columnKey === 'subtype' || columnKey === 'comhist' || columnKey === 'uniquebarcode') {
          const maxWordLength = result.maxWord.length;
          let maxLimit: number = columnKey === 'actiontype' ? 15 : 40;
          let maxLines: number = 3;
          maxLimit = (maxWordLength / maxLines) > maxLimit ? Math.ceil(maxWordLength / maxLines) : maxLimit;
          const maxRows = (maxWordLength > maxLimit) ? Math.ceil(maxWordLength / maxLimit) : 1;
          var canvas = document.createElement('canvas');
          var context: any = canvas.getContext('2d');
          context.font = '500 13px Roboto';
          let strArr = this.chunkSubstr(result.maxWord.toString(), maxLimit);
          var arr = strArr.map((str:any) => context.measureText(str).width);
          var longestStr = Math.ceil(Math.max(...arr));
          var textWidth = maxRows > 1 ? longestStr : context.measureText(result.maxWord).width;
          ColumnWidthService.setColumnMinWidth(columnKey, textWidth + 14);
          if ((columnKey === 'subtype' || columnKey === 'uniquebarcode' || columnKey === 'comhist') && result2 !== undefined) {
            let strArr2 = this.chunkSubstr(result2.maxWord.toString(), maxLimit);
            var arr2 = strArr2.map((str:any) => context.measureText(str).width);
            var tallestStr = Math.ceil(Math.max(...arr2));
            let rows = tallestStr / (textWidth + 14);
            const rowHeight = (Math.ceil(rows) * 17.5) + 2;
            ColumnWidthService.setColumnMinHeight(rowHeight);
          }
          else {
            const rowHeight = (maxRows * 17.5) + 2;
            ColumnWidthService.setColumnMinHeight(rowHeight);
          }
        } else {
          const maxLengthString = Math.max(...currentWord.map((el: any) => el.length));
          console.log(result, "maxLengthWord")
          var canvas = document.createElement('canvas');
          var context: any = canvas.getContext('2d');
          context.font = '500 13px Roboto';
          var textWidth = context.measureText(result.maxWord).width;
          console.log("word , maxlength ", result.maxWord, textWidth)
          ColumnWidthService.setColumnMinWidth(columnKey, textWidth + 14);
          const rowHeight = (maxLengthString * 17.5) + 2;
          ColumnWidthService.setColumnMinHeight(rowHeight);
        }
      }
    }
  }

  static chunkSubstr(str: string, chunkSize: number) {
    let chunks = [];
    for (let i = 0; i < str.length; i += chunkSize) {
      chunks.push(str.slice(i, i + chunkSize));
    }
    return chunks;
  }

  static actionTypeSetter(params: any) {
    let msg = "";
    let constants = new Constants();
    msg = params ? constants.HistoryActionType.filter(x => x.value == params)[0]?.name : ""
    return msg

  }
}
